import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchContractor'
})
export class SearchContractorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
